import React, { Component, PropTypes } from 'react';
import SearchBar from '../../../../shared-components/SearchBar/component';
import classes from './brandsSearchBar.scss';

class BrandsSearchBar extends Component {
  render() {
    const { searchBarModel,
      model: { allBrands },
      dispatch,
      staticRender,
      onBrandSelect,
      onKeyEnter,
      inlineStyle,
    } = this.props;

    const searchBarProps = {
      items: allBrands,
      numVisibleItems: 5,
      model: searchBarModel,
      dispatch,
      staticRender,
      onBrandSelect,
      onKeyEnter,
      inlineStyle,
    };

    return (
      <div className={classes.brandsSearchBar} style={ inlineStyle }>
        <SearchBar { ...searchBarProps } />
      </div>
    );
  }
}

BrandsSearchBar.propTypes = {
  model: PropTypes.object.isRequired,
  searchBarModel: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  onBrandSelect: PropTypes.func.isRequired,
  onKeyEnter: PropTypes.func,
  staticRender: PropTypes.bool,
  inlineStyle: PropTypes.object,
};

export default BrandsSearchBar;



/** WEBPACK FOOTER **
 ** ./apps/homepage/components/BrandsSearchBar/BrandsSearchBar.js
 **/